var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBoxRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-box-right "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 7.5,
    stroke: "#E2E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3591 12L9.67952 8.3204C9.34478 7.98567 9.34478 7.44296 9.67952 7.10822C10.0143 6.77348 10.557 6.77348 10.8917 7.10822L15.1774 11.3939C15.5122 11.7287 15.5122 12.2714 15.1774 12.6061L10.8917 16.8918C10.557 17.2266 10.0143 17.2266 9.67952 16.8918C9.34478 16.5571 9.34478 16.0144 9.67952 15.6796L13.3591 12Z",
    fill: "#454551"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBoxRight);
export default __webpack_public_path__ + "static/media/arrow-box-right.afea8242181553044562d5399f9716c4.svg";
export { ForwardRef as ReactComponent };